import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Canvas from './Canvas';

export default function ImageDrawModal({ show, title, image, onClose }) {
    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            size="xl"
            backdrop="static"
            keyboard={false}
            dialogClassName="eye-draw-modal"
            contentClassName="eye-draw-modal__content"
        >
            <Modal.Header className="eye-draw-modal__header border-0 d-flex align-items-center">
                <div className="d-flex align-items-center gap-3 min-width-0">
                    <span className="eye-draw-modal__icon-badge flex-shrink-0">
                        <i className="bi bi-easel"></i>
                    </span>
                    <div className="min-width-0">
                        <Modal.Title className="h5 mb-0 fw-semibold text-truncate">{title}</Modal.Title>
                        <div className="small text-muted">Draw on the template to annotate findings</div>
                    </div>
                </div>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary rounded-pill ecx-modal__close-btn ms-auto flex-shrink-0"
                    onClick={onClose}
                    aria-label="Close"
                >
                    <i className="bi bi-x-lg"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="eye-draw-modal__body">
                <div className="eye-draw-modal__canvas-wrap">
                    <Canvas image={image} />
                </div>
            </Modal.Body>
        </Modal>
    );
}

ImageDrawModal.propTypes = {
    show: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    image: PropTypes.any.isRequired,
    onClose: PropTypes.func.isRequired,
};
